module.exports = __webpack_public_path__ + "static/media/foot-logo.3c5dcf5a.png";